import { CommonResponseModel, driverIdReq, vendorReq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class VendorService extends CommonAxiosService {
    private VendorController = "/vendor";

    async createVendor(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VendorController + "/createVendor", payload)
    }

    async getAllVendors(req?:driverIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VendorController + "/getAllVendors",req)
    }

    async getActiveAllVendor(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VendorController + "/getActiveAllVendor")
    }
    async updateVendor(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.VendorController + '/updateVendor', dto)
    }

    async activateOrDeactivateVendor(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VendorController + "/activateOrDeactivateVendor", payload)
    }

    async getAllVendorRequests(req:any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VendorController + "/getAllVendorRequests",req)
    }

    async getAllvendorCoderequest(req?:vendorReq): Promise<CommonResponseModel> {
        // console.log(req,'uuuuuuuuuuuuuuuuuuuu');
        
        return this.axiosPostCall(this.VendorController + "/getAllvendorCoderequest",req)
    }
    
}